import { WIN_STAGES } from "../lib/constants";
import { useLang } from "../context/LanguageContext";
import { statusLabel } from "../lib/statusI18n";

const COLORS = {
  "BROUILLON": "text-ink-secondary border-white/15 bg-white/5",
  "IDÉE DÉPOSÉE": "text-cyan border-cyan/30 bg-cyan/5",
  "RETENU PAR NOS ÉQUIPES": "text-electric border-electric/40 bg-electric/10",
  "NON RETENU PAR NOS ÉQUIPES": "text-red-400 border-red-400/40 bg-red-500/10",
  "EN ÉTUDE": "text-cyan border-cyan/30 bg-cyan/5",
  "PRÉSÉLECTIONNÉE": "text-electric border-electric/40 bg-electric/10",
  "FINALISTE": "text-electric border-electric/40 bg-electric/10",
  "SÉLECTIONNÉE": "text-void border-cyan bg-cyan",
  "APPLICATION TERMINÉE": "text-void border-cyan bg-cyan",
};

export default function StatusBadge({ status, className = "" }) {
  const { tf: t } = useLang();
  const cls = COLORS[status] || "text-cyan border-cyan/30 bg-cyan/5";
  const isWin = WIN_STAGES.includes(status);
  return (
    <span
      data-testid="status-badge"
      className={`inline-flex items-center gap-1.5 border px-2.5 py-1 text-[10px] font-600 uppercase tracking-[0.14em] ${cls} ${className}`}
    >
      {isWin && <span className="text-[11px]">🏆</span>}
      {statusLabel(t, status)}
    </span>
  );
}
